<template>
  <g>
    <!-- cable for P8 side A -->
    <simplex-cable 
      v-if="['12', '8'].includes(fiberCount) && plugSideACount === 1"
      v-bind="Object.assign({}, $props, {cableColor: remainingWhipsA.length === 1 ? remainingWhipsA[0].color : 'default'})" 
      :is-pigtail="true" />

    <!-- cable for P8 side B -->
    <simplex-cable 
      v-if="['12', '8'].includes(fiberCount) && plugSideBCount === 1"
      v-bind="Object.assign({}, $props, {cableColor: remainingWhipsB.length === 1 ? remainingWhipsB[0].color : 'default'})" 
      :transform="`translate(${svgWidth} 0) scale(-1 1)`"
      :is-pigtail="true" />

    <component :is="cableType" v-bind="Object.assign(
      $props, 
      { 
        whipColor: 
          remainingWhipsA.length === 1 
            ? remainingWhipsA[0].color 
            : 'default'
      })"
    />
    
  </g>
</template>

<script>
import DuplexZipCable from './DuplexZipCable'
import DuplexCable from './DuplexCable'
import SimplexCable from './SimplexCable'
import TrunkCable from './TrunkCable'

import { mapGetters } from 'vuex'

export default {
  props: {
    cableColor: {
      type: String
    },
    fiberCount: {
      type: [String, Number]
    }, 
    svgHeight: {
      type: Number
    },
    svgWidth: {
      type: Number
    },
    svgPadding: Number,
    svgCladdingMargin: Number,
    svgCloakMargin: Number,
    thickness: {
      type: String,
      default: null
    },
    isPigtail: {
      type: Boolean,
      default: false
    },
    plugSideACount: {
      type: Number,
      default: null
    },
    plugSideBCount: {
      type: Number,
      default: null
    },
    plexSideA: {
      type: String,
      default: null
    },
    plexSideB: {
      type: String,
      default: null
    }
  },
  computed: {
    cableType () {
      switch(this.fiberCount) {
        case '2x1':
          return 'DuplexZipCable'
        case 2:
        case '2':
          return 'DuplexCable'
        case '4':
        case '6':
        case '8':
        case '12':
        case '16':
        case '24':
        case '3x8':
        case '4x8':
        case '6x8':
        case '8x8':
        case '12x8':
        case '16x8':
        case '2x12':
        case '4x12':
        case '6x12':
        case '8x12':
        case '12x12':
        case '8x2':
        case '16x2':
        case '24x2':
          return 'TrunkCable'
        default:
          return 'SimplexCable'
      }
      
    },
    ...mapGetters([
      'remainingWhipsA',
      'remainingWhipsB',
    ])
  },
  components: {
    DuplexZipCable,
    DuplexCable,
    SimplexCable,TrunkCable
  }
}
</script>

<style>

</style>
